export default __webpack_public_path__ + "static/media/provide-liquidity_mobile.05e4bd8f.png";